import React from 'react';
import { companyInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: t.nav.applications, href: '#applications' },
    { label: t.nav.solutions, href: '#soluciones' },
    { label: t.nav.advantages, href: '#avantages' },
    { label: t.nav.whyChoose, href: '#whychoose' },
    { label: t.nav.products, href: '#produits' },
    { label: t.nav.videos, href: '#videos' },
    { label: t.nav.faq, href: '#faq' },
    { label: t.nav.contact, href: '#contact' },
  ];

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6 rounded-lg p-3 inline-block" style={{ backgroundColor: '#f8f6f1' }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_smartsystems-py/artifacts/jn4xljzk_saved_image_1767497994308.png" 
                alt="Smart Systems Paraguay" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-slate-400 mb-6 max-w-md">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-6">{t.footer.navigation}</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-blue-400 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-white mb-6">{t.footer.contact}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#1F4FD8' }} />
                <div>
                  <span className="text-slate-300 text-sm font-semibold block">{companyInfo.name}</span>
                  <span className="text-slate-400 text-sm">{companyInfo.address}</span>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0" style={{ color: '#1F4FD8' }} />
                <a
                  href={`tel:${companyInfo.whatsapp}`}
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                >
                  {companyInfo.whatsapp}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-5 h-5 flex-shrink-0" style={{ color: '#1F4FD8' }} />
                <a
                  href={`https://wa.me/${companyInfo.whatsapp.replace(/\+/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                  data-testid="footer-whatsapp-link"
                >
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 flex-shrink-0" style={{ color: '#1F4FD8' }} />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} {companyInfo.name}. {t.footer.rights}
            </p>
            <p className="text-slate-500 text-sm">
              {t.footer.madeIn} <span style={{ color: '#1F4FD8' }}>SMARTMICRO®</span> {t.footer.madeInGermany}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
